export default {
    must_field: "Необходимо заполнить поле",
    field_can_not_be_updated:
        "Область вставки содержит столбец с данными только для чтения, вставить данные в такой столбец невозможно",
    invalid_value: "Некорректное значение",
    error_in_form_before_submit: "Невозможно отправить данные на сервер",
    company_validation_bad_name: "Необходимо заполнить наименование",
    account_transfer_not_balanced: "Необходимо сбалансировать операции",
    wrong_credentials: "Отказано в доступе",
    cam_media_error: "Камера не доступна",
    err_on_upload_camera_photo: "Не удалось загрузить фото",
    unauthorized: "Доступ запрещен",
    "Error: not_deletable_account": "Этот счет нельзя удалить",
    "Error: account_has_transfers": "У этого счета есть проводки",
    "Error: account_has_children": "У этого счета есть субсчета",
    ajax_error: "Сбой соединения с сервером",
    unique_LIST_COMPANY_inn: "ИНН занят",
    unique_LIST_COMPANY_inn_kpp: "Филиал с таким ИНН и КПП уже существует",
    unique_LIST_COMPANY_contacts: "Такая фирма уже существует",
    unique_INVOICE_INCOMING_doc_number: "Такой счет уже существует",
    unique_INVOICE_OUTGOING_doc_number: "Такой счет уже существует",
    unique_LIST_USER_login: "Такой логин уже существует",
    unique_OWNER_UNIT_unit_number: "Такой подвижной состав уже существует",
    unique_OWN_ROLLING_STOCK_UNIT_unit_number: "Такой подвижной состав уже существует",
    email_cant_be_send: "Не удалось отправить письмо",
    no_selected_elements: "Не выбрано ни одного элемента",
    on_remove_constraint_relation_error: "Удаление невозможно, т.к. есть зависимые строки",
    EA0x0001: "Недостаточно привилегий для удаления строк со следующими номерами записей: {=rows}",
    EA0x0002: "Недостаточно привилегий для восстановления строк со следующими номерами записей: {=rows}",
    EA0x0003: "Недостаточно привилегий для перемещения в корзину строк со следующими номерами записей: {=rows}",
    access_denied_trash_task_by_not_creator: "Вы не можете удалить эти задачи: {=rows}",
    access_denied_untrash_task_by_not_creator: "Вы не можете восстановить эти задачи: {=rows}",
    access_denied_remove_task_by_not_creator: "Вы не можете удалить эти задачи: {=rows}",
    order_no_units: "У этого заказа нет грузовых единиц",
    "new row for relation \"list_order_positions\" violates check constraint \"valid_quantity_sum\"":
        "Превышено максимальное количество товара",
    order_has_no_units_related_to_declaration: "Невозможно связать, т.к. в заказе нет грузовых единиц с таким номером",
    import_error_500: "Произошла ошибка во время загрузки файла, проверьте формат файла",
    import_classes_invalid_attrs_map_file: "Файл соответствия для импорта excel в БД отсутствует или содержит ошибки",
    import_classes_invalid_excel_file: "Импортируемый excel-файл имеет некооректный формат",
    import_classes_columns_not_recognized: "Не удалось определить столбцы таблицы",
    import_classes_update_invalid_part_number: "Ошибка обновления в строке с артикулом '{= part_number}'",
    import_classes_insert_invalid_part_number: "Ошибка добавления в строке с артикулом '{= part_number}'",
    on_remove_invoice_that_has_closing_documents_error:
        "Невозможно удалить счёт, для которого созданы закрывающие документы",
    on_remove_invoice_that_has_1c_unload:
        "Невозможно удалить счёт, выгруженный в 1с",
    on_remove_invoice_that_has_archived_order_error: "Невозможно удалить счёт, т.к. он привязан к архивному заказу",
    on_remove_invoice_that_statement_date_less_then_fin_settings_date_error: "Невозможно удалить счёт, т.к. дата акта относится к закрытому периоду",
    on_remove_invoice_that_has_an_actual_payment_date_error:
        "Невозможно удалить счёт для которого определена фактическая дата оплаты",
    on_restore_mirror_invoice_when_outgoing_invoice_is_deleted:
        "Невозможно восстановить зеркальный входящий счет, когда исходящий счет удален",
    system_status_delete_error: "Невозможно удалить системный статус",
    system_status_update_error: "Невозможно изменить системный статус",
    no_rights_to_order_archiving:
        "Отклонение фактической доходности от планируемой более 5%! Невозможно перенести заказ в архив.",
    not_get_to_order_archiving:
        "Невозможно достать заказ из архива. Отклонение фактической доходности от планируемой более 5%!",
    model_should_inherit_from_RowModel: "model должна наследоваться от RowModel",
    error_creating_model: "Ошибка при создании модели",
    cant_remove_or_update_status: "Нельзя редактировать или удалять системные статусы",
    "no documents": "Список документов пуст",
    server_timeout: "Превышено время ожидания ответа от сервера",
    dont_remove_system_capital_account: "Нельзя изменить или удалить системный счет",
    dont_remove_account_with_operations: "Нельзя удалить счет с проводками",

    wrong_account_type_child: "Тип счета потомка должен совпадать с родителем",
    wrong_account_liquidity_child: "Ликвидность счета потомка должна совпадать с родителем",
    wrong_account_currency_child: "Валюта счета потомка должна совпадать с родителем",
    wrong_account_type_parent: "Тип счета потомка должен совпадать с родителем",
    wrong_account_liquidity_parent: "Ликвидность счета потомка должна совпадать с родителем",
    wrong_account_currency_parent: "Валюта счета потомка должна совпадать с родителем",

    null_json: "У проводки должны быть операции",
    need_currency: "Операции проводки должны иметь валюту",
    expected_two_operations: "Должно быть не меньше двух операций в проводке",
    expected_single_currency: "Все операции проводки должны быть в одной валюте",
    need_debet_or_credit: "У каждой операции должен быть дебет или кредит",
    only_debet_or_credit: "Операция может содержать только дебет или только кредит",
    wrong_debet_credit_sum: "Сумма дебета должна быть равна сумме кредита",

    dont_update_operation_id_account: "У операции проводки нельзя сменить счет",
    account_with_balance_cannot_have_children: "Счет не может иметь потомков, если у него не нулевой баланс",
    invalid_liquidity: "Ликвидность должна соответствовать типу счета",
    dont_remove_part_number: "Нельзя удалить инвойс, по которому выставлены счета",
    dont_to_untie_part_number: "Нельзя отвязать груз от инвойса, по которому выставлены счета",
    dont_edit_part_number: "Нельзя редактировать инвойс, по которому выставлены счета",
    error_client_and_preclient_role: "Нельзя назначать роль \"Клиент\" и \"Потенциальный Клиент\" одновременно",

    single_start_point_if_more_than_one_end_point:
        "Нельзя выбрать более одного места отправления, если выбрано более одного места назначения",
    no_unique_list_company_name: "Контрагент с наименованием '{=companyName}' уже существует",
    company_already_exists: "Компания уже существует",
    inn_error: "Совпадение по ИНН",
    no_unique_list_company_inn: "Контрагент с ИНН №{=inn} уже существует",
    fin_oper_has_untrashed_invoices_error: "Нельзя удалить фин. операцию, по которой выставлены счета",
    fin_oper_has_untrashed_invoices_on_clear_error:
        "Нельзя очистить ставки по фин. операции, по которой выставлены счета",
    payment_order_has_untrashed_invoices_error: "Нельзя удалить ПП, к которому привязаны счета",
    no_edit_total_sum_vat_for_foreign_currency_position:
        "Сумму НДС позиции, валюта которой отличается от валюты счёта, редактировать нельзя",
    dont_remove_operation_unit: "Нельзя удалить груз, на который выставлены счета",
    must_first_apply_the_changes: "Прежде необходимо применить внесённые изменения",
    contracts_fea_addition_is_main_must_be_only_one: "Основное дополнительное соглашение может быть только одно!!",
    cannot_delete_template_attached_log_scheme: "Нельзя удалить шаблон, привязанный к лог схеме",
    "can_not_change_start/end_point_of_train_whith_unit":
        "Нельзя изменить станцию отправления/прибытия поезда с привязанным грузом",
    not_unique_mmsi: "Данный MMSI уже используется",
    not_unique_bik: "Данный БИК уже используется",
    has_linked_unit_on_next_operation: "Существуют связанные грузы на последующей операции",
    owner_unit_number_exists: "Экспортные перевозки для {=unit_number} существуют",
    cannot_save_if_invisible: "Необходимо поставить галку \"Видимость\"",
    visible_sum_of_docs_of_fin_operation_more_then_visible_sum_of_fin_operation:
        "Сумма стоимости привязанных документов не может превышать сумму фин операции",
    delete_system_tab_error: "Нельзя удалить системную вкладку #{=id}",
    trash_manager_bonus_rec_error: "Невозможно удалить запись, проставлена галка \"Период закрыт\"",
    trash_linked_rec_with_manager_bonus_closed_period_error:
        "Невозможно удалить запись, она относится к премии с закрытым периодом",
    max_users: "Достигнут предел количества пользователей",
    cannot_create_capital_transfer_for_account_with_wrong_liquidity: "Если у счета указан тип «Расход», то ликвидность должна быть «Прямая себестоимость», иначе нельзя создать проводку",
    actual_date_coming_not_current_date: "Нельзя архивировать заказ прошедшей или будущей датой",
    actual_date_logist_complete_not_current_date: "Нельзя проставить не нынешнюю дату",
    wrong_doc_date: "Неверная дата счета",
    unique_constraint_service_for_resubmission_index: "Поле “Номенклатура за перевыставление“ может быть заполнено только на одной номенклатуре",
    sum_payment_more_then_gtd_sum_diff: "Сумма платежа превышает остаток, не разнесённый по ДТ",
    sum_payment_more_then_payment_orders_sum_diff: "Сумма платежа превышает сумму, не закрытую SWIFT",
    repetitions_of_category: "Обнаружены повторяющиеся категории: {=names}",
    unique_service_combination_name: "Комбинация с таким именем уже существует",
    same_service_combination: "Данная комбинация уже выбрана",
    duplicate_sys_serial_number: "Данный номер заказа уже существует"
};
